// extracted by mini-css-extract-plugin
export var standaloneTable = "_gd-0";
export var standaloneTableWithBodyFill = "_gd-1";
export var withExtraHeader = "_gd-2";